import React from 'react';

import { InfoField } from '@occc/ui-design-system';
import { AwardPriceOverrideFragment } from '@occc/graphql';

interface IPriceOverrideAwardProps {
  award: AwardPriceOverrideFragment;
}

export const PriceOverrideAward: React.FC<IPriceOverrideAwardProps> = ({ award }) => {
  return <InfoField label='Maximum Cost' value={award?.maximumCost} />;
};
